import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 bg-[#1e4d7b] text-white overflow-hidden relative" data-id="element-150">
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-151">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-sm font-medium mb-8 backdrop-blur-sm border border-white/20" data-id="element-152">
          <ShieldCheck className="h-4 w-4 text-[#4a90c2]" data-id="element-153" />
          El Sistema Hogar Blindado (3P)
        </motion.div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-154">
          Por esto tu hogar queda blindado contra los piojos.
        </h2>

        <p className="text-xl text-blue-100 leading-relaxed max-w-2xl mx-auto" data-id="element-155">
          La combinación de tratamiento capilar, textiles y rutina diaria corta
          el ciclo por completo.
        </p>
      </div>

      {/* Background pattern */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-156">
        <div className="absolute right-0 top-0 w-64 h-64 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-157"></div>
        <div className="absolute left-0 bottom-0 w-64 h-64 bg-[#4a90c2] rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-158"></div>
      </div>
    </section>;
}